import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    version: "1.0",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.iconSize,
    height: _ctx.iconSize,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, [
    _createElementVNode("g", {
      transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
      fill: _ctx.iconColor,
      stroke: "none"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("path", { d: "M2493 5110 c-151 -31 -252 -153 -263 -314 l-5 -80 -85 -17 c-504\n-102 -909 -438 -1120 -930 -124 -289 -164 -467 -245 -1074 -85 -642 -155 -979\n-261 -1268 -49 -135 -170 -384 -254 -527 -66 -110 -79 -153 -59 -189 21 -37\n62 -54 159 -62 121 -11 4286 -10 4397 0 104 11 141 25 162 62 20 36 7 79 -59\n189 -84 143 -205 392 -254 527 -110 299 -168 583 -266 1308 -55 411 -77 533\n-126 711 -186 685 -625 1130 -1234 1253 l-85 17 -1 48 c-4 115 -24 169 -92\n247 -69 78 -203 121 -309 99z m-373 -978 c51 -25 80 -74 80 -136 0 -73 -24\n-105 -120 -162 -277 -165 -433 -457 -486 -909 -9 -77 -23 -159 -31 -183 -40\n-114 -195 -136 -267 -38 -34 45 -37 80 -21 215 61 521 228 878 510 1093 109\n83 214 138 264 138 20 0 52 -8 71 -18z" }, null, -1),
      _createElementVNode("path", { d: "M1920 364 c0 -17 79 -110 143 -169 82 -76 210 -144 322 -171 92 -22\n258 -22 350 0 112 27 240 95 322 171 64 59 143 152 143 169 0 3 -288 6 -640 6\n-352 0 -640 -3 -640 -6z" }, null, -1)
    ]), 8, _hoisted_2)
  ], 8, _hoisted_1))
}